import { render, staticRenderFns } from "./create-categories.vue?vue&type=template&id=09cc437e&"
import script from "./create-categories.vue?vue&type=script&lang=js&"
export * from "./create-categories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports